export const PROFILE_TYPE = {
  create: '등록',
  edit: '수정',
};

/* 프로필 등급 */
export const PROFILE_GRADE_OPTIONS = [
  { value: 'BEGINNER', label: '초급' },
  { value: 'INTERMEDIATE', label: '중급' },
  { value: 'ADVANCED', label: '고급' },
  { value: 'EXPERT', label: '특급' },
];

export const PROFILE_GRADE_CONVERTER = {
  BEGINNER: '초급',
  INTERMEDIATE: '중급',
  ADVANCED: '고급',
  EXPERT: '특급',
};

/* 프로필 성별 */
export const PROFILE_GENDER_OPTIONS = [
  { value: 'M', label: '남자' },
  { value: 'F', label: '여자' },
];

export const PROFILE_GENDER_CONVERTER = {
  M: '남자',
  F: '여자',
};

/* 프로필 근무구분 */
export const PROFILE_WORK_TYPE_OPTIONS = [
  { value: 'FULLTIME', label: '정규직' },
  { value: 'CONTRACT', label: '외주' },
];

export const PROFILE_WORK_TYPE_CONVERTER = {
  FULLTIME: '정규직',
  CONTRACT: '외주',
};

/* 프로필 학력 졸업상태 */
export const PROFILE_EDUCATION_STATUS_OPTIONS = [
  { value: 'GRADUATED', label: '졸업' },
  { value: 'DROPOUT', label: '중퇴' },
  { value: 'EXPECTED', label: '졸업예정' },
];

export const PROFILE_EDUCATION_STATUS_CONVERTER = {
  GRADUATED: '졸업',
  DROPOUT: '중퇴',
  EXPECTED: '졸업예정',
};
